import React, { useRef, useState } from 'react'
import Card from '../../../Components/Card/Card'
import { FileUpload } from 'primereact/fileupload'
import { Toast } from 'primereact/toast'
import { downloadFile, uploadHandler } from '../../../Services/ArchivosService'
import { Button } from 'primereact/button'

import { getListadoArchivos, descargarArchivo, eliminarArchivo } from '../../../../API/IT/Test/TestRequests'

const TestITScreen = () => {

    const toast = useRef(null);
    const fileUpload = useRef(null);


    const [listadoArchivos, setListadoArchivos] = useState([])

    const referencia = {
        IdRef: 1,
        Codigo: 'REF-0002'
    }

    const subirArchivo = async (e) => {

        const inputs = [
            {
                name: 'IdRef',
                type: 'text',
                value: referencia.IdRef
            },
            {
                name: 'Codigo',
                type: 'text',
                value: referencia.Codigo
            }
        ]

        uploadHandler({e, inputs, toast, ref: fileUpload})
        getArchivos()
        fileUpload.current.clear()

    }

    const getAnexos = async (IdMemo) => {
        // const a = await getArchivoMemo(IdMemo);
        // setAnexos(a)
    }

    const getArchivos = async () => {
        const a = await getListadoArchivos('REF-0002');
        console.log(a);
        setListadoArchivos(a)
    }

    const getArchivo = async (nombre) => {
        const a = await descargarArchivo('REF-0002', nombre);
        console.log( a);
        downloadFile(a, nombre)
    }

    const eliminar = async (nombre) => {
        const a = await eliminarArchivo('REF-0002', nombre);
        console.log( a);
        getArchivos()
    }

    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={<div><h3>TEST IT</h3></div>}

                contenido={<div style={{ height: '90vh' }} className='p-4'>


                    <FileUpload ref={fileUpload} name="demo" url="./upload"  multiple customUpload uploadHandler={subirArchivo} />

                    <div>
                        <Button label='Listado archivos' onClick={getArchivos} />

                        <div>
                            {listadoArchivos.map((a, i) => {
                                return <div className='d-flex gap p-2 border' style={{alignItems: 'center' }} key={i}>
                                    <div className='col-4'>{a}</div>
                                    <Button icon='pi pi-download' onClick={e => getArchivo(a)} />
                                    <Button icon='pi pi-trash' severity='danger' onClick={e => eliminar(a)} />
                                </div>
                            })}
                        </div>
                    </div>
                </div>}
            />
        </div>
    )
}

export default TestITScreen